export const getTrackingHandler = map => {
  return key => {
    return map.has(key) ? map.get(key) : () => {};
  };
};